export const transformInstallmentOrders = (data) => {
  return {
    ...data,
    results: data?.results?.map((order) => ({
      ...order,
      due_date: order?.student_admission_installments?.[0]?.window_end_date,
      program_name: order?.invoice_items?.[0]?.program_fee?.program?.name,
      academic_year_name:
        order?.invoice_items?.[0]?.program_fee?.academic_year?.name,
      grade: order?.invoice_items?.[0]?.student?.standard,
      grade_uuid: order?.invoice_items?.[0]?.student?.standard?.uuid
    }))
  }
}

export const transformPlayCareTransactions = (data) => {
  return {
    ...data,
    results: data?.results?.map((transaction) => ({
      ...transaction,
      parent: {
        uuid: transaction?.user,
        parent_name: transaction?.coin_transaction?.enrolment?.parent_full_name
      }
    }))
  }
}
